module.exports = __webpack_public_path__ + "images/mileage-icon.7517206b234503e04b1fa14c29e8cd9e.png";